<script lang="ts">
  import { page } from '$app/stores'
  import { Button } from '@bond/components'
  import { META_TITLE_SUFFIX } from '$lib/constants/meta'
  import { STRINGS } from '$lib/constants/strings'
  import type { LayoutData } from './$types'
  import { utils } from '$lib/utils'

  export let data: LayoutData
  $: ({ lang } = data)
  $: localeRoute = utils.getRoute(lang)
</script>

<svelte:head>
  {#if $page.status === 404}
    <title>{STRINGS[lang].ERROR_PAGE_NOT_FOUND}{META_TITLE_SUFFIX}</title>
  {:else}
    <title>{STRINGS[lang].ERROR_SOMETHING_WENT_WRONG}{META_TITLE_SUFFIX}</title>
  {/if}
</svelte:head>
<div class="container">
  {#if $page.status === 404}
    <h1>404</h1>
    <p>{STRINGS[lang].ERROR_PAGE_NOT_FOUND}</p>
    <Button rounded prependIcon="ph-house-fill" href={localeRoute('/')}>
      {STRINGS[lang].ERROR_BACK_TO_HOME}
    </Button>
  {:else}
    <h1>{STRINGS[lang].ERROR_SOMETHING_WENT_WRONG}</h1>
  {/if}
</div>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;

    p {
      @media screen and (max-width: breakpoints.$breakpoint-sm) {
        margin-bottom: 1em;
      }
    }
  }
</style>
